module.exports = __webpack_public_path__ + "img/icn_circle_green.91e48c02.svg";